<tds-header>

<tds-header-hamburger id="demo-hamburger" aria-label="Open application drawer" aria-haspopup="true" tdsAriaLabel="header"
    aria-expanded="false" (click)="toggleMobileSideMenu()"></tds-header-hamburger>

<tds-header-title>{{ title }}</tds-header-title>

<tds-header-dropdown slot="end" no-dropdown-icon class="user-dropdown" tdsAriaLabel="header-dropdown">
    
  <div slot="icon">
      @if(pic; as profilePic) {
      <img [src]="profilePic" alt="Profile picture" />
      } @else {
      <img src="https://www.svgrepo.com/show/384676/account-avatar-profile-user-6.svg" alt="Default user avatar" />
      }
  </div>
    
  <tds-header-dropdown-list size="lg">
    <tds-header-dropdown-list-user 
        header="{{ userName }}"
        subheader="{{ placeOfWork }}">
    </tds-header-dropdown-list-user>
      

      @if(userReservation()){
      <tds-header-dropdown-list-item>
      <a> 
          Reserva: {{userReservation()?.tableName}} (P{{userReservation()?.building}}-{{userReservation()?.region}})
      </a>
      </tds-header-dropdown-list-item>
      }

    <tds-header-dropdown-list-item>

      <a (click)="toggleMode()">
          
          @if(mode == "tds-mode-light"){

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" width = "24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
          </svg>

          }@else{

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" width = "24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
          </svg>

          }         

      </a>

    </tds-header-dropdown-list-item>

  </tds-header-dropdown-list>
</tds-header-dropdown>

<tds-header-brand-symbol slot="end">
  <a routerLink="/" aria-label="Scania - red gryphon on blue shield"></a>
</tds-header-brand-symbol>

</tds-header>